import { GOOGLE_MAP_API_KEY } from '@model/const/api-keys.ts';
import { LOCALE_DEFAULT } from '@model/const/locales';

export default {
    data() {
        return {
            map: null,
            isLoadedGoogleMaps: false,
        };
    },

    computed: {
        locale() {
            return this.$store.state.geolocation.finalLocale || LOCALE_DEFAULT;
        },
        language() {
            // TODO: should this use getLanguageCodeFromLocale?
            return this.locale.split('-').shift();
        },
    },

    async mounted() {
        await this.$nextTick();

        if (typeof window === 'undefined') return;

        await this.waitForBody();

        try {
            await this.loadGoogleMapsScript();
            this.isLoadedGoogleMaps = true;
            this.addMap?.();
            this.addMarkers?.();
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('❌ Failed to load Google Maps:', err);
        }
    },

    methods: {
        waitForBody() {
            return new Promise((resolve) => {
                if (document.body) {
                    resolve(undefined); // explicit resolve to avoid lint
                    return;
                }

                const id = setInterval(() => {
                    if (document.body) {
                        clearInterval(id);
                        resolve(undefined); // again, resolve with undefined
                    }
                }, 50);
            });
        },

        loadGoogleMapsScript() {
            return new Promise((resolve, reject) => {
                if (window.google?.maps) {
                    resolve(undefined);
                    return;
                }

                if (window.GoogleMapsInit) {
                    const checkInterval = setInterval(() => {
                        if (window.google?.maps) {
                            clearInterval(checkInterval);
                            resolve(undefined);
                        }
                    }, 100);
                    return;
                }

                const params = 'loading=async&callback=GoogleMapsInit&libraries=marker';
                const src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&${params}&language=${this.language}`;
                const script = document.createElement('script');
                script.setAttribute('src', src);
                script.setAttribute('async', '');
                script.setAttribute('defer', '');

                window.GoogleMapsInit = () => resolve(undefined);
                script.onerror = reject;

                document.body.appendChild(script);
            });
        },
    },
};
